import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide.min.css";

import { lockBodyScroll, unlockBodyScroll } from "./scroll-lock";

// Scroll to top button
document.addEventListener("DOMContentLoaded", function () {
  const backToTopBtn = document.getElementById("back-to-top");

  // Show/hide button based on scroll position
  window.addEventListener("scroll", function () {
    if (window.pageYOffset > 300) {
      backToTopBtn.classList.add("visible");
    } else {
      backToTopBtn.classList.remove("visible");
    }
  });

  // Scroll to top when button is clicked
  backToTopBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});

// Fullscreen Menu Animation
document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.getElementById("menuToggle");
  const menuClose = document.getElementById("menuClose");
  const fullscreenMenu = document.getElementById("fullscreenMenu");
  const menuBackdrop = fullscreenMenu
    ? fullscreenMenu.querySelector(".menu-backdrop")
    : null;
  const MENU_ANIMATION_DURATION = 100; // Keep JS timings aligned with CSS transitions when closing
  const header = document.querySelector(".header");

  function updateMenuOffset() {
    if (!fullscreenMenu) return;
    // Assicura che il menù copra l'intero viewport, senza lasciare spazio per l'header
    fullscreenMenu.style.top = "0";
    fullscreenMenu.style.height = "100vh";
  }

  function resetMenuOffset() {
    if (!fullscreenMenu) return;
    fullscreenMenu.style.top = "";
    fullscreenMenu.style.height = "";
  }

  // Open menu
  menuToggle.addEventListener("click", function () {
    updateMenuOffset();
    fullscreenMenu.classList.add("active");
    fullscreenMenu.setAttribute("aria-hidden", "false");

    menuToggle.classList.add("active");
    lockBodyScroll("menu"); // Prevent scrolling when menu is open

    if (menuBackdrop) {
      menuBackdrop.classList.remove("is-visible");
      // Force reflow so the next addition retriggers the animation immediately
      void menuBackdrop.offsetWidth;
      menuBackdrop.classList.add("is-visible");
    }

    // Small delay to ensure the menu is visible before animating content
    setTimeout(() => {
      const menuContent = document.querySelector(".menu-content");
      if (menuContent) {
        menuContent.style.opacity = "1";
        menuContent.style.transform = "translateX(0)";
      }
    }, 0);
  });

  // Close menu
  menuClose.addEventListener("click", function () {
    closeMenu();
  });

  // Close menu when pressing Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && fullscreenMenu.classList.contains("active")) {
      closeMenu();
    }
  });

  // Close menu when clicking outside the content area
  if (menuBackdrop) {
    menuBackdrop.addEventListener("click", function () {
      closeMenu();
    });
  }

  fullscreenMenu.addEventListener("click", function (event) {
    const menuPanel = fullscreenMenu.querySelector(".menu-panel");
    const clickedCloseButton = menuClose && menuClose.contains(event.target);

    if (!menuPanel) {
      return;
    }

    if (!menuPanel.contains(event.target) && !clickedCloseButton) {
      closeMenu();
    }
  });

  // Function to close the menu
  function closeMenu() {
    const menuContent = document.querySelector(".menu-content");
    if (menuContent) {
      menuContent.style.opacity = "0";
      menuContent.style.transform = "translateX(40px)";
    }

    if (menuBackdrop) {
      menuBackdrop.classList.remove("is-visible");
    }

    // Delay the menu hiding to allow content animation to complete
    setTimeout(() => {
      fullscreenMenu.classList.remove("active");
      menuToggle.classList.remove("active");
      fullscreenMenu.setAttribute("aria-hidden", "true");
      unlockBodyScroll("menu"); // Restore scrolling
      resetMenuOffset();
    }, MENU_ANIMATION_DURATION);
  }

  window.addEventListener("resize", function () {
    if (fullscreenMenu && fullscreenMenu.classList.contains("active")) {
      updateMenuOffset();
    }
  });
});

// Reduce animations functionality
document.addEventListener("DOMContentLoaded", function () {
  const reduceBtn = document.getElementById("reduceAnimationsBtn");
  if (!reduceBtn) return;

  let animationsReduced = false;

  // Testi per i due stati
  const texts = {
    reduce: "Riduci animazioni",
    resume: "Riprendi animazioni",
  };

  // Funzione per aggiornare il pulsante
  function updateButton(isReduced) {
    const textNode = reduceBtn.childNodes[0]; // Il primo nodo di testo
    const iconSpan = reduceBtn.querySelector(".animation-button");

    if (textNode && iconSpan) {
      textNode.textContent = isReduced
        ? texts.resume + " "
        : texts.reduce + " ";

      // Cambia l'icona
      const iconImg = iconSpan.querySelector("img");
      if (iconImg) {
        iconImg.src = isReduced ? "img/svg/play.svg" : "img/svg/pause.svg";
        iconImg.alt = isReduced ? "Play Icon" : "Pause Icon";
      }
    }
  }

  // Utility: forza il ricalcolo del layout dei carousel
  function refreshCarousels() {
    // Forza un reflow e notifica i listener di resize (il vertical carousel riallinea le slide su resize)
    requestAnimationFrame(() => {
      // Reflow
      document.body.offsetHeight;
      // Trigger resize per agganciare la logica di updateCarousel/handleResize
      window.dispatchEvent(new Event("resize"));
    });
  }

  // Funzione per controllare se un elemento è visibile nel viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top <
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right > 0
    );
  }

  reduceBtn.addEventListener("click", function (e) {
    e.preventDefault();

    if (!animationsReduced) {
      // RIDUCI ANIMAZIONI

      // 1. Disattiva animazioni CSS
      document.body.classList.add("reduce-animations");

      // 2. Disattiva animazioni JS - rimuovi solo animate-in, mantieni fade-in-top per la visibilità
      document.querySelectorAll(".animate-in").forEach((el) => {
        el.classList.remove("animate-in");
      });

      // 3. Disconnetti l'observer per evitare nuove animazioni
      if (window.fadeObserver) {
        window.fadeObserver.disconnect();
      }

      // 4. Stoppa i video di background
      document.querySelectorAll("video[autoplay][loop]").forEach((video) => {
        if (
          video.id === "verticalCarouselVideo" ||
          video.id === "sfidaVideo" ||
          video.id === "approfondimentiVideo"
        ) {
          video.pause();
        }
      });

      animationsReduced = true;
      updateButton(true);

      // 5. Riallinea i componenti che dipendono da transform/resize (es. vertical carousel)
      refreshCarousels();
    } else {
      // RIPRENDI ANIMAZIONI

      // Riattiva animazioni CSS
      document.body.classList.remove("reduce-animations");

      // 3. Riavvia i video di background
      document.querySelectorAll("video[autoplay][loop]").forEach((video) => {
        if (
          video.id === "verticalCarouselVideo" ||
          video.id === "sfidaVideo" ||
          video.id === "approfondimentiVideo"
        ) {
          video
            .play()
            .catch((e) => console.log("Video autoplay prevented:", e));
        }
      });

      animationsReduced = false;
      updateButton(false);

      // Riallinea dopo il ripristino
      refreshCarousels();
    }
  });
});

// Page overlay: prevent FOUC and start animation when ready
document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("page-overlay");
  if (!overlay) return;

  // Se l'utente ha già visto l'animazione, rimuovi subito l'overlay e non mostrarlo più
  try {
    if (localStorage.getItem("overlaySeen") === "true") {
      overlay.remove();
      return;
    }
  } catch (e) {}

  // Sblocca l'overlay (se nascosto inline) e avvia quando il browser ha effettuato il primo paint
  if (overlay.style && overlay.style.display === "none") {
    overlay.style.display = "flex";
  }

  // Usa requestAnimationFrame per evitare flash prima che gli stili siano applicati
  requestAnimationFrame(() => {
    overlay.classList.add("ready");
  });
});

// Splide carousel (sfide-che-uniscono)
let splideInstance = null;

function mountSplideCarousel() {
  const splideElement = document.querySelector(".splide-container .splide");
  if (!splideElement) return;

  if (splideInstance) {
    splideInstance.destroy();
    splideInstance = null;
  }

  const isMobile = window.innerWidth < 768;
  const savedIndex = sessionStorage.getItem("splideIndex");
  const shouldRestorePosition = sessionStorage.getItem("hasNavigated");
  const initialIndex =
    shouldRestorePosition && savedIndex ? parseInt(savedIndex, 10) : 0;

  splideInstance = new Splide(splideElement, {
    type: "slide",
    drag: isMobile,
    perPage: 1,
    focus: "center",
    padding: { left: isMobile ? "5%" : "15%", right: isMobile ? "5%" : "15%" },
    gap: "2rem",
    arrows: false,
    pagination: isMobile,
    start: initialIndex,
    breakpoints: {
      991: {
        padding: { left: "10%", right: "10%" },
      },
      767: {
        padding: { left: "5%", right: "5%" },
      },
    },
  }).mount();

  let hasMoved = false;

  splideInstance.on("moved", () => {
    if (!hasMoved) {
      sessionStorage.setItem("hasNavigated", "true");
      hasMoved = true;
    }
    sessionStorage.setItem("splideIndex", splideInstance.index);
  });

  splideInstance.on("dragged", () => {
    if (!hasMoved) {
      sessionStorage.setItem("hasNavigated", "true");
      hasMoved = true;
    }
    sessionStorage.setItem("splideIndex", splideInstance.index);
  });

  function changeSlideClass() {
    splideInstance.Components.Slides.forEach((slideComponent) => {
      slideComponent.slide.classList.remove("entering");
    });
    const currentSlide = splideInstance.Components.Slides.getAt(
      splideInstance.index
    );
    if (currentSlide) {
      currentSlide.slide.classList.add("entering");
    }
  }

  if (isMobile) {
    splideInstance.Components.Slides.forEach((slideComponent) => {
      slideComponent.slide.classList.add("entering");
    });
  } else {
    changeSlideClass();
    splideInstance.on("move", changeSlideClass);
  }

  const prevBtn = document.querySelector(".splide-prev");
  const nextBtn = document.querySelector(".splide-next");

  if (prevBtn && nextBtn) {
    prevBtn.onclick = () => {
      splideInstance.go("<");
      if (!isMobile) changeSlideClass();
      if (!hasMoved) {
        sessionStorage.setItem("hasNavigated", "true");
        hasMoved = true;
      }
      sessionStorage.setItem("splideIndex", splideInstance.index);
    };
    nextBtn.onclick = () => {
      splideInstance.go(">");
      if (!isMobile) changeSlideClass();
      if (!hasMoved) {
        sessionStorage.setItem("hasNavigated", "true");
        hasMoved = true;
      }
      sessionStorage.setItem("splideIndex", splideInstance.index);
    };
  }

  if (isMobile) {
    const splideContainer = document.querySelector(".splide-container");
    const pagination = document.querySelector(".splide__pagination");
    if (splideContainer && pagination) {
      splideContainer.appendChild(pagination);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const hasSplideCarousel = document.querySelector(".splide-container .splide");
  if (!hasSplideCarousel) return;

  sessionStorage.removeItem("hasNavigated");
  mountSplideCarousel();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(mountSplideCarousel, 200);
  });
});
